export default "__VITE_ASSET__DE1k65Fw__"